// src/components/Header.js
import React from 'react';
import { Box, Paper } from '@mui/material';
import LOGORSA from '../assets/LOGORSA.png'; // Asegúrate de que esta ruta sea correcta

function Header() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
      <Paper elevation={0} sx={{ width: 360, height: 120, display: 'flex', justifyContent: 'center', alignItems: 'center', mr: 2 }}>
        <img src={LOGORSA} alt="LOGORSA Logo" style={{ maxWidth: '100%', maxHeight: '100%' }} />
      </Paper>
    </Box>
  );
}

export default Header;